import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Button
} from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  BubbleChart,
} from '@mui/icons-material';

// --- The New Modal Component ---
function ProductModal({ pergola, onClose }) {
  if (!pergola) return null;

        const handleQuoteClick = () => {
    document.getElementById("contact-form")?.scrollIntoView({ behavior: "smooth" });
    onClose();
  };

  return (
    <motion.div
      // The semi-transparent backdrop
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose} // Close modal when clicking the backdrop
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(26, 26, 26, 0.85)', // #1a1a1a with 85% opacity
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '16px',
      }}
    >
      <motion.div
        // The white content box
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 50, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the box
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          width: '100%',
          maxWidth: '1000px',
          height: 'auto',
          maxHeight: '90vh',
          display: 'flex',
          overflow: 'hidden',
          position: 'relative',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        }}
      >
        {/* Close Button */}
<IconButton
  aria-label="close modal"
  onClick={onClose}
  sx={{
    position: 'absolute',
    top: 8,
    right: 8,
    color: 'grey.700',
    backgroundColor: '#fff', // Initial solid white background
    zIndex: 10,
    transition: 'background-color 0.2s ease-in-out', // Adds a smooth transition
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.65)', // White with 85% opacity on hover
    },
  }}
>
  <CloseIcon />
</IconButton>

        {/* Left Side: Features */}
        <Box sx={{ flex: 1.2, p: { xs: 3, md: 5 }, overflowY: 'auto' }}>
          <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
            {pergola.title}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Key Features
          </Typography>
          <List dense>
            {pergola.features.map((feature, index) => (
              <ListItem key={index} disablePadding sx={{mb: 1}}>
                <ListItemIcon sx={{ minWidth: '36px' }}>
                  <CheckCircleOutlineIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={feature} />
              </ListItem>
            ))}
          </List>
          <Button variant='contained' onClick={handleQuoteClick}>
                Get a free quote now
          </Button>
        </Box>

        {/* Right Side: Image */}
        <Box
          sx={{
            flex: 1,
            minHeight: '400px',
            display: { xs: 'none', md: 'block' }, // Hide image on small screens
            backgroundImage: `url(${pergola.imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </motion.div>
    </motion.div>
  );
}

export default ProductModal;